export const SHOPPING_LIST_START_PARAMETER = "shopping_list";
export const PRICE_ALERTS_START_PARAMETER = "alerts";
export const PRICE_WATCH_SETTINGS_START_PREFIX = "watch_edit_";
export const STORE_PREFERENCES_START_PARAMETER = "stores";
export const HOME_SCREEN_SHORTCUT_START_PARAMETER = "shortcut";

export function isShoppingListStartParameter(
  value: string | null,
): boolean {
  return value === SHOPPING_LIST_START_PARAMETER;
}

export function isPriceAlertsStartParameter(value: string | null): boolean {
  return value === PRICE_ALERTS_START_PARAMETER;
}

/** A route identifier, never authorization: resolve only within the signed-in user's rules. */
export function parsePriceWatchSettingsStartParameter(value: string | null): string | null {
  if (!value?.startsWith(PRICE_WATCH_SETTINGS_START_PREFIX)) return null;
  const id = value.slice(PRICE_WATCH_SETTINGS_START_PREFIX.length);
  return id.length === 36 && /^[a-f\d]{8}-[a-f\d]{4}-[1-5][a-f\d]{3}-[89ab][a-f\d]{3}-[a-f\d]{12}$/i.test(id) ? id : null;
}

export function isHomeScreenShortcutStartParameter(
  value: string | null,
): boolean {
  return value === HOME_SCREEN_SHORTCUT_START_PARAMETER;
}
